import React from 'react';
import { SkeletonComponent } from '@design-system';

export const NewsSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '0' }}>
            {[...Array(1)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '214px',
                        width: '100%',
                        margin: '-2px auto 8px',
                        borderRadius: '18px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
